import { getAccountManager } from "@bevco/Services/AccountManagerService";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    onSuccess(result: any): any;
    customerId: string;
}
interface Props {
    apiResult: any;
    apiParameter: any;
}

type HandlerType = Handler<Parameter, Props> & HasOnSuccess;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.customerId;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getAccountManager(props.apiParameter);
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};
const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];
const getAccountManagerInfo = createHandlerChainRunner(chain, "getAccountManagerInfo");
export default getAccountManagerInfo;
